import React from "react";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaYoutube } from "react-icons/fa";
import "./Media.css";
import { color } from "framer-motion";

const Media = () => {
  return (
    <div className="media-page">
      <section className="section about-us-section full-width">
        <h2 className="section-title-first">Media</h2>
      </section>
      {/* Uploaded Video Section */}
      {/* <div className="uploaded-video">
        <video width="560" height="315" controls>
          <source src="display.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div> */}

<div className="uploaded-video">
  <video className="full-screen-video" loop autoPlay muted>
    <source src="display.mp4" type="video/mp4" />
    Your browser does not support the video tag.
  </video>
</div>
      {/* Video Section */}
      <p className="v1-h">Our Youtube Videos</p>
      <div className="videos">
        
      <iframe width="560" height="315" 
      src="https://www.youtube.com/embed/WxDGANtvlMw?si=aUFxHnVt5yeF3UE3" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen>
      </iframe>

      <iframe width="560" height="315" 
      src="https://www.youtube.com/embed/d2dqSBypRpQ?si=cDrw7NA-WjgdgK7j" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen>
      </iframe>

      <iframe width="560" height="315" 
      src="https://www.youtube.com/embed/hozMjWqN_8Q?si=WIc6ksPQzh5YTafJ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen>
      </iframe>

      <iframe width="560" height="315" 
      src="https://www.youtube.com/embed/pB0dLiQhlcQ?si=MBdQ4OPItQj8MF-0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen>
      </iframe>
      </div>
    </div>
  );
};

export default Media;
